export default __webpack_public_path__ + "static/media/kount.b3bc3137.png";